// extracted by mini-css-extract-plugin
export var cityLinkText = "city-selection-view-module--cityLinkText--ecc90";
export var cityRow = "city-selection-view-module--cityRow--8b627";
export var container = "city-selection-view-module--container--dcc92";
export var prefectureText = "city-selection-view-module--prefectureText--93dc5";